module.exports = __webpack_public_path__ + "b015732ed3a20414063677bf26941c09.svg";